export const IMPORT_CSV_WRONG_SIZE_MESSAGE = 'File size limit is 2MB';
export const IMPORT_CSV_FILE_MESSAGE = 'Please upload a CSV file.';
export const IMPORT_CSV_FILE_DESCRIPTION = 'Drag and drop the file or click to upload button';
